import styled from "styled-components";

export const QueueCardContainer = styled.div`
    border: 1px solid rgba(255,255,255,0.5);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 8px;
    margin-top: 16px;
    margin-bottom: 16px;
    background-color: #1e1e1e;
`;
export const CardDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
export const CardHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    gap: 4px;

    span {
        color: rgba(255,255,255,0.4 );
    }

    h3 {
        color: #FFFFFF;
        display: inline;
        font-size: 12px;
        font-weight: 600;
    }
`;
export const CardNumber = styled.div`
    box-sizing: border-box;
    align-items: center;
    display: flex;
    height: 40px;
    width: 80px;

    h4 {
        font-size: 12px;
        padding: 4px 12px;
    };
`;
export const AttributesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 0; /* 8px vertical gap, 0px horizontal gap */

  h4 {
    font-size: 10px;
    font-weight: 500;
    padding: 0 8px; /* 0px vertical padding, 8px horizontal padding */
    width: fit-content;
  }
`;
export const CardContent = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;
export const LeftCardContent = styled.div`
    align-items: center;
    display: flex;
`;

